import { styled, SxProps } from '@mui/system';

const Img = styled('img')(() => ({}));

interface Hex1Props {
  sx: SxProps;
}
export const Hex2 = ({ sx }: Hex1Props) => {
  return <Img sx={sx} alt="hexagono 2" src={'/static/hexagonos/Hex2.svg'} />;
};
